import React from 'react';
import { Box, Copy, Optional } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import CarouselSwatch from '../ColorDisplay/CarouselSwatch';
import ColourSwatches from '../TrimPackages/Details/Colours/ColourSwatches';
import { stripMarkdownHeading } from '../../utils/markdown';
import themeStyles from './ThreeSixty.styles';
var SwatchName = themeStyles.apply(Copy, 'SwatchesContent');
var SwatchContainer = themeStyles.apply(Box, 'ColorContent');
var ContentColumn = themeStyles.apply(Box, 'ContentColumn');
var SwatchContent = function (_a) {
    var shouldShowSwatchCarousel = _a.shouldShowSwatchCarousel, selectedColorName = _a.selectedColorName, selectedColorIndex = _a.selectedColorIndex, onCarouselColorSelected = _a.onCarouselColorSelected, currentColors = _a.currentColors, onColorSelected = _a.onColorSelected, swatchLength = _a.swatchLength, isDark = _a.isDark, noWrap = _a.noWrap;
    return (React.createElement(ContentColumn, null,
        React.createElement(SwatchName, { fontFamily: "bold", size: "nav", "data-testid": "cy-colour-name" }, compiler(stripMarkdownHeading(selectedColorName))),
        React.createElement(Optional, { when: shouldShowSwatchCarousel },
            React.createElement(SwatchContainer, null,
                React.createElement(CarouselSwatch, { selected: selectedColorIndex, setSelected: onCarouselColorSelected, swatches: currentColors, length: swatchLength, isDark: isDark }))),
        React.createElement(Optional, { when: !shouldShowSwatchCarousel },
            React.createElement(SwatchContainer, { mb: [0, '24px'] },
                React.createElement(ColourSwatches, { swatches: currentColors, gtmInteractionType: "change exterior color", setSelected: onColorSelected, isDark: isDark, hideSwatchName: true, noWrap: noWrap, setCurrentSlide: function () { } })))));
};
export default SwatchContent;
